import { requestApi } from 'utils';

export const updateCurrentPaymentMethodApiRequest = (paymentMethod) =>
  requestApi.mutate(`
  mutation UpdateCurrentPaymentMethod {
    updateStripeCurrentPaymentMethod(paymentMethod: "${paymentMethod}")
  }
`);
